import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Theme } from '@mentimeter/ragnar-ui/themes';
import {
  CONTENT_THEME,
  type CustomContentThemeType,
} from '@mentimeter/content-ui/Theme';
import { Pattern } from '../Pattern/Pattern';

export type SectionT = BoxT & CustomContentThemeType;

/**
 * @deprecated This component is deprecated and will be removed in a future release.
 *
 * Section component for themed layout purposes.
 *
 * @remarks
 * This component is no longer maintained and may be removed in future releases.
 * Please migrate to SectionContainer or other recommended alternative components for section layouts.
 *
 * @param theme - Optional theme object to style the section with colors and patterns
 * @param rest - Additional props passed to the underlying Box component
 * @param ref - Ref forwarded to the root div element
 *
 * @returns A themed section layout component with pattern support
 *
 * @warning
 * Do not use this component in new code. It will be deleted in the future.
 * Use SectionContainer instead for new implementations.
 */
export const Section = React.forwardRef<HTMLDivElement, SectionT>(
  ({ theme, ...rest }, ref) => {
    const generalStyling: BoxT = {
      px: [4, 'space12', 6, 6],
      py: [4, 'space12', 'space18', 5],
      width: '100%',
      alignItems: 'center',
      as: 'section',
      overflow: 'hidden',
    };
    if (!theme) {
      return <Box ref={ref} {...generalStyling} {...rest} />;
    } else if (theme.colors.includes('pattern')) {
      return (
        <Pattern patternColor={theme.colors}>
          <Theme theme={CONTENT_THEME[theme.colors]}>
            <Box ref={ref} {...generalStyling} {...rest} />
          </Theme>
        </Pattern>
      );
    } else {
      return (
        <Theme theme={CONTENT_THEME[theme.colors]}>
          <Box bg="bg" ref={ref} {...generalStyling} {...rest} />
        </Theme>
      );
    }
  },
);
